<template>
    <kiosk-team-details :teamId="props.teamId">
        <div class="col-span-12 lg:col-span-10 flex flex-col w-full justify-center">
            <team-users
                :teamId="props.teamId"
                :readOnly="team.status === 'closed'"
                :isKiosk="true"
                :hasContactGroups="hasContactGroups"
                :isAdminOrOwner="true"
            />
        </div>
    </kiosk-team-details>
</template>

<script setup>
import { computed } from 'vue';
import KioskTeamDetails from '../details/KioskTeamDetails.vue';
import TeamUsers from '~/components/settings/teams/membership/TeamUsers.vue';
import { useTeamDetails } from '../composables/useTeamDetails';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
});

const { team } = useTeamDetails();

const hasContactGroups = computed(() => Boolean(team.value?.team_attributes?.contact_groups));
</script>
